// Libs
import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { NavLink } from 'react-router-dom';

// Hooks
import useUser from '../../../hooks/useUser';

// Utils
import { supportTabs } from '../../../constants/support';

import { useStyles } from './PagesSwitcherStyles';

const PagesSwitcher = (props) => {
  const { activeTab, setActiveTab } = props;
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ isKiteUser });

  return (
    <Tabs
      value={activeTab}
      onChange={(event, newValue) => setActiveTab(newValue)}
      className={classes.tabs}>
      {supportTabs.map((tab) => (
        <Tab
          key={tab.path}
          label={tab.label}
          component={NavLink}
          to={tab.path}
          className={classes.tab}
        />
      ))}
    </Tabs>
  );
};

export default PagesSwitcher;
